import Vue from 'vue'
import { HTTP } from '../../../../utils/httpCommonUtil'
import { BallPulseLoader } from 'vue-loaders';
import VueSimpleSpinner from 'vue-simple-spinner'
import { getRestParamErrorMessage, getRestResponseErrorMessage } from '@/utils/serverErrorMessageUtil';
import RolesModal from './RolesModal.vue';

export default Vue.component('admin-users-card', {
  name: 'AdminUsersCard',
  data () {
    let color: any
    return {
      cardExpanded: false,
      color: color,
      loadingTableData: false,
      errorMessage: '',
      adminUserData: [ { id: 1, firstName: '', lastName: '', email: '', active: 1, oldFirstName: '', oldLastName: '', oldEmail: '', oldActive: 1, showRolesDisplay: false, isEditing: false, isSaving: false} ],
      rolesFocusedAdminUser: { roles: [{id: 0, name: ''}]},
      showModal: false
    }
  },
  components: {
    VueSimpleSpinner,
    BallPulseLoader,
    RolesModal
  },
  created: function () {
    if (this.cardExpanded) { this.getAdminUsers() } else { this.adminUserData = []; }
  },
  filters: {
    activeDisplay (boo: boolean) {
      return boo ? 'Active' : 'Inactive';
    }
  },
  methods: {
    expandCard () {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        this.getAdminUsers()
      }
    },
    getAdminUsers () {
      let self = this
      let showLoadingSpinnerTimeout = setTimeout(function () {
        self.loadingTableData = true;
      }, 0);
      self.errorMessage = ''
      HTTP.get('/api/users/')
      .then(function (response) {
        let users = response.data.data;
        users.map(function (user: any) { user.isEditing = false; user.isSaving = false; user.showRolesDisplay = false; });
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingTableData = false;
        self.adminUserData = users;
      })
      .catch(function (error) {
        clearTimeout(showLoadingSpinnerTimeout);
        self.loadingTableData = false;
        self.errorMessage = error;
      })
    },
    addRow () {
      this.adminUserData.push(
        { id: +('-' + new Date().getTime()), firstName: '', lastName: '', email: '', active: 1, oldFirstName: '', oldLastName: '', oldEmail: '', oldActive: 1, showRolesDisplay: false, isEditing: true, isSaving: false}
      );
    },
    editRow (adminUser: any) {
      adminUser.oldFirstName = adminUser.firstName;
      adminUser.oldLastName = adminUser.lastName;
      adminUser.oldEmail = adminUser.email;
      adminUser.oldActive = adminUser.active;
      adminUser.isEditing = !adminUser.isEditing;
    },    
    cancelEditRow (adminUser: any) {
      if (adminUser.id < 0) {
        let index = this.adminUserData.indexOf(adminUser);
        this.adminUserData.splice(index, 1);
      }
      adminUser.firstName = adminUser.oldFirstName;
      adminUser.lastName = adminUser.oldLastName;
      adminUser.email = adminUser.oldEmail;
      adminUser.active = adminUser.oldActive
      adminUser.isEditing = !adminUser.isEditing;
    },
    saveEditRow (adminUser: any) {
      let self = this;
      adminUser.isSaving = true;
      // If the User's ID is negative, it has not yet been saved to the DB. Request a "Create". 
      if (adminUser.id < 0) {
        HTTP.post('/api/users/', adminUser)
        .then(function (response) {
          self.getAdminUsers();
          // Announce the returned message via temporary popup.
          self.$notify({
            group: 'main',
            type: 'success',
            title: 'Success!',
            text: 'An email is being sent to the new user with login information.',
            // duration: 5000
          });

          adminUser.oldFirstName = adminUser.firstName;
          adminUser.oldLastName = adminUser.lastName;
          adminUser.oldEmail = adminUser.email;
          adminUser.oldActive = adminUser.active;
          adminUser.isEditing = !adminUser.isEditing;
          adminUser.isSaving = false;
        })
        .catch(function (error) {
          console.log('response Error!');
          adminUser.isSaving = false;
          let errorMessages = [];
          let noErrorsFound = true;
          errorMessages.push( getRestParamErrorMessage(error, 'firstName') );
          errorMessages.push( getRestParamErrorMessage(error, 'lastName') );
          errorMessages.push( getRestParamErrorMessage(error, 'email') );
          errorMessages.push( getRestParamErrorMessage(error, 'active') );
          errorMessages.forEach(function (errorMessage) {
            if (!errorMessage.length) { return; }
            noErrorsFound = false;
            self.$notify({
              group: 'main',
              type: 'error',
              title: 'Error Creating User',
              text: errorMessage,
              duration: 5000
            });           
          });
          if (noErrorsFound) {            
            let generalError = getRestResponseErrorMessage(error);
            self.$notify({
              group: 'main',
              type: 'error',
              title: 'Error Creating User',
              text: generalError ? generalError : 'An error occurred creating user.',
              duration: 5000
            });
          }
        })
      } else {
        // Else request an update to an existing Admin User in the DB.
        HTTP.put('/api/users/', adminUser)
        .then(function (response) {
          // self.getAdminUsers();
          adminUser.oldFirstName = adminUser.firstName;
          adminUser.oldLastName = adminUser.lastName;
          adminUser.oldEmail = adminUser.email;
          adminUser.oldActive = adminUser.active;
          adminUser.isEditing = !adminUser.isEditing;
          adminUser.isSaving = false;
        })
        .catch(function (error) {
          console.error('response Error!');
          // self.errorMessage = error;
          console.log(error);
          adminUser.isSaving = false;
          let errorMessages = [];
          let noErrorsFound = true;
          errorMessages.push( getRestParamErrorMessage(error, 'firstName') );
          errorMessages.push( getRestParamErrorMessage(error, 'lastName') );
          errorMessages.push( getRestParamErrorMessage(error, 'email') );
          errorMessages.push( getRestParamErrorMessage(error, 'active') );
          errorMessages.forEach(function (errorMessage) {
            if (!errorMessage.length) { return; }
            noErrorsFound = false;
            self.$notify({
              group: 'main',
              type: 'error',
              title: 'Error Updating User',
              text: errorMessage,
              duration: 5000
            });           
          });
          if (noErrorsFound) {
            let generalError = getRestResponseErrorMessage(error);
            self.$notify({
              group: 'main',
              type: 'error',
              title: 'Error Updating User',
              text: generalError.length ? generalError : 'An error occurred updating user.',
              duration: 5000
            });
          }
        })
      }

    },
    toggleActive (adminUser: any) {
      adminUser.active = !adminUser.active;
      let self = this;
      HTTP.put('/api/users/', adminUser)
      .then(function (response) {
        // If successfull, do nothing as the UI has already been updated.
        // self.getAdminUsers();
      })
      .catch(function (error: any) {
        // If un-successful, change the UI to adminUser.active = !adminUser.active and display the Error Notification.
        console.error('response Error!');
        console.error(error);        
        adminUser.active = !adminUser.active;
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Active Status Error Updating User',
          text: 'Something went wrong updating ' + adminUser.firstName + '\'s active status!',
          duration: 5000
        });       
      })
    },
    showRolesModal (adminUser: any) {
      this.rolesFocusedAdminUser = adminUser;
      this.showModal = true;
      return;
    },
    closeRolesModal () {
      this.showModal = false;
      return;
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/settings/cards/adminUsers/AdminUsersCard.ts